import React from 'react';
import PropTypes from 'prop-types';
import { Hidden } from 'react-grid-system';

import { colors } from 'settings/theme';
import BundleUtil from 'utils/BundleUtil';
import ScreenSizeUtil from 'utils/ScreenSizeUtil';
import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';

import Typography from 'components/vistaprintUILibrary/Typography';

function HowItWorksStep(props) {
  const {
    iconSrc,
    stepNumber,
    title,
    renderDescription,
    screenClass,
  } = props;

  const isSmallScreen = ScreenSizeUtil.isSmallScreen(screenClass);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        marginBottom: isSmallScreen ? 0 : 20,
      }}
    >
      <Hidden xs>
        <img
          src={BundleUtil.getFullyQualifiedURL(iconSrc)}
          alt={title}
          style={{
            height: 60,

            marginBottom: 20,
          }}
        />
      </Hidden>
      <Typography
        variant="heading2"
        style={{
          marginBottom: 15,
        }}
        text={`${stepNumber}. ${title}`}
      />
      <Hidden xs>
        <div
          style={{
            height: 1,
            width: '100%',
            maxWidth: 260,
            backgroundColor: colors.border,
          }}
        />
        <div
          style={{
            boxSizing: 'border-box', // include margin/padding when calculating width

            marginTop: 15,
            paddingLeft: 10,
            paddingRight: 10,
            maxWidth: 260,

            textAlign: 'center',
          }}
        >
          {renderDescription()}
        </div>
      </Hidden>
    </div>
  );
}

HowItWorksStep.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  stepNumber: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  renderDescription: PropTypes.func.isRequired,
};

HowItWorksStep.propTypes = {
  ...withScreenClassPropTypes,
};

export default withScreenClass(HowItWorksStep);



// WEBPACK FOOTER //
// ./src/components/HowItWorksStep.js